// extracted by mini-css-extract-plugin
module.exports = {"container":"mobileTopMatchItem__container___Gm07W","title":"mobileTopMatchItem__title___384Kk"};